import { Text } from '@chakra-ui/react'
import type { FC } from 'react'
import { useCallback } from 'react'

import { Switch } from '@app/components/ui/switch'
import { useStrategyMapContext } from '@app/pages/strategies/strategyMapContext'

const MapSimulationToggle: FC = () => {
  const { mapMode, setMapMode } = useStrategyMapContext()
  const simulationMode = mapMode === 'simulation'

  const onCheckedChange = useCallback(
    (e) => {
      setMapMode(e.checked ? 'simulation' : 'build')
    },
    [setMapMode]
  )

  return (
    <Switch checked={simulationMode} onCheckedChange={onCheckedChange} size="xs" labelFirst>
      <Text fontSize="xs">Simulation mode</Text>
    </Switch>
  )
}

export default MapSimulationToggle
